import {
  formatPriceInput,
  writeSession
} from "../../sharedGlobal";

import {
  writeSoftwareProductToSession,
  writeSupportAddonToSession,
} from "./methods";

import {
  moduleNamespace,
  SET_SOFTWARE_PRODUCT,
  SET_LOADING_STATE,
} from "./constants.js";

/**
 * Set a field on the user-created software product.
 */
export function setSoftwareProductField(state, field) {
  const fieldChange = Object.keys(field)[0];
  delete state.errors['softwareProduct.'+fieldChange];
  state.softwareProduct = Object.assign(
    {},
    state.softwareProduct,
    field
  );
  writeSoftwareProductToSession(state.softwareProduct);
}

/**
 * Set a field on the user-created software support addon product.
 */
export function setSupportAddonField(state, field) {
  const fieldChange = Object.keys(field)[0];
  delete state.errors['supportAddon.'+fieldChange];
  state.supportAddon = Object.assign(
    {},
    state.supportAddon,
    field
  );
  writeSupportAddonToSession(state.supportAddon);
}

/**
 * Set a field on one of the prices of the user-created software product.
 */
export function setSoftwareProductPriceField(state, {currencyCode, ...field}) {
  const fieldToChange = Object.keys(field)[0];

  clearPricingErrors(state);

  const formattedInput = formatPriceInput(field[fieldToChange]);

  const rawPrice = parseInt(
    formattedInput.replace(/[,.]/g, '')
  ) ?? 0;

  state.softwareProduct.prices[currencyCode] = {
    ...state.softwareProduct.prices[currencyCode],
    [fieldToChange+'Raw']: !isNaN(rawPrice) ? rawPrice : 0,
  };

  writeSoftwareProductToSession(state.softwareProduct);
}

/**
 * Set a field on one of the prices of the user-created support addon product.
 */
export function setSupportAddonPriceField(state, {currencyCode, ...field}) {
  const fieldToChange = Object.keys(field)[0];

  Object.entries(state.supportedCurrencies).forEach(([currencyCode]) => {
    delete state.errors[`supportAddon.prices.${currencyCode}.${fieldToChange}Raw`];
  });

  const formattedInput = formatPriceInput(field[fieldToChange]);

  const rawPrice = parseInt(
    formattedInput.replace(/[,.]/g, '')
  ) ?? 0;

  state.supportAddon.prices[currencyCode] = {
    ...state.supportAddon.prices[currencyCode],
    [fieldToChange+'Raw']: !isNaN(rawPrice) ? rawPrice : 0,
  };

  writeSupportAddonToSession(state.supportAddon);
}

/**
 * Set the errors object.
 */
function setErrors(state, { errors, namespace, joi }) {
  let newErrors = errors;

  if (joi === true) {
    // Flattening the Joi error format into dot-notation keyed errors
    newErrors = errors.reduce((total, e) => {
      const { message, path } = e;
      path.unshift(namespace);
      total[path.join('.')] = message;
      return total;
    }, state.errors);

    return;
  }

  state.errors = newErrors;
}

import {
  SET_SOFTWARE_PRICES,
  SET_SOFTWARE_PRODUCT_FIELD,
  SET_SUPPORT_ADDON_FIELD,
  SET_SOFTWARE_PRODUCT_PRICE_FIELD,
  SET_SUPPORT_ADDON_PRICE_FIELD,
  SET_ERRORS,
  TOGGLE_SUPPORT_ADDON,
  TOGGLE_ENABLED_CURRENCY,
} from './constants.js';

import {validateSoftwareProduct, validateSupportAddon} from "./schema/product";
import {clearPricingErrors} from "./actions";

export default {
  [SET_SOFTWARE_PRODUCT_FIELD]: setSoftwareProductField,
  [SET_SUPPORT_ADDON_FIELD]: setSupportAddonField,
  [SET_SOFTWARE_PRODUCT_PRICE_FIELD]: setSoftwareProductPriceField,
  [SET_SUPPORT_ADDON_PRICE_FIELD]: setSupportAddonPriceField,
  [SET_ERRORS]: setErrors,
  [SET_SOFTWARE_PRICES]: (state, payload) => { state.softwarePrices = payload; },
  [SET_SOFTWARE_PRODUCT]: (state, payload) => { state.softwareProduct = payload; },
  [TOGGLE_SUPPORT_ADDON]: (state) => {
    state.enableSupportAddon = !state.enableSupportAddon;
    writeSession(moduleNamespace, 'enableSupportAddon', JSON.stringify(state.enableSupportAddon));
  },
  [TOGGLE_ENABLED_CURRENCY]: (state, payload) => {
    delete state.errors['softwareProduct.prices'];
    state.supportedCurrencies[payload] = {
      ...state.supportedCurrencies[payload],
      enabled: !state.supportedCurrencies[payload].enabled,
    };
    writeSession(moduleNamespace, 'supportedCurrencies', JSON.stringify(state.supportedCurrencies));
  },
  [SET_LOADING_STATE]: (state, boolean) => state.loading = boolean,
};
